import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useFacebookPixel } from '../hooks/useFacebookPixel';
interface CTAProps {
  text: string;
  destination: string;
  isSticky?: boolean;
  className?: string;
  eventName?: string;
  eventParams?: object;
}
export const CTA = ({
  text,
  destination,
  isSticky = false,
  className = '',
  eventName,
  eventParams = {}
}: CTAProps) => {
  const {
    trackEvent
  } = useFacebookPixel();
  const baseClasses = 'flex items-center justify-center py-4 px-6 bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-lg shadow-md text-lg transition-all duration-200 w-full';
  const stickyClasses = isSticky ? 'fixed bottom-0 left-0 right-0 max-w-md mx-auto z-50 rounded-none shadow-lg' : '';
  const handleClick = () => {
    // Track the click event with Facebook Pixel if eventName is provided
    if (eventName && window.fbq) {
      trackEvent(eventName, {
        content_name: text,
        content_category: 'Hair Care',
        ...eventParams
      });
    }
  };
  return <Link to={destination} className={`${baseClasses} ${stickyClasses} ${className}`} onClick={handleClick} data-id="element-20">
      {text} <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-21" />
    </Link>;
};